import { WebApi } from '../../services/WebApi'

const state = () => ({
  addingBooking: false,
  booking: null
})

const mutations = {
  setAdding (state, value) {
    state.addingBooking = value
  },
  setBooking (state, booking) {
    state.booking = booking
  },
  clearBooking (state) {
    state.addingBooking = false
    state.booking = null
  }
}

const actions = {
  addBookingAnonymous ({ commit }, { siteId, payload, router }) {
    return new Promise((resolve, reject) => {
      commit('setAdding', true)
      WebApi.post('Portal/' + siteId + '/Booking/Anonymous', payload)
        .then(response => {
          const result = response.data
          commit('setBooking', response.data)
          if (result.token) {
            const token = result.token
            router.push({ name: 'paymentProcessorAnonymous', query: { siteId, token } })
          }
          commit('ApplicationEvents/triggerBookingAdded', response.data, { root: true })
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setAdding', false))
    })
  },
  addBookingAuthenticated ({ commit }, { siteId, payload, router }) {
    return new Promise((resolve, reject) => {
      commit('setAdding', true)
      WebApi.post('Portal/' + siteId + '/Booking/Authenticated', payload)
        .then(response => {
          const result = response.data
          commit('setBooking', response.data)
          commit('ApplicationEvents/triggerBookingAdded', response.data, { root: true })
          if (result.token) {
            const token = result.token
            if (token) {
              router.push({ name: 'paymentProcessorAuthenticated', query: { siteId, token } })
            }
          }
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setAdding', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
